import { t } from '@lingui/macro';
import { CompanyType } from './types';

export const getCompanyTypes = (): CompanyType[] => [
    {
        code: '1',
        type: t`Product`,
        isRackbeatStepVisible: true,
    },
    {
        code: '2',
        type: t`Service`,
        isRackbeatStepVisible: true,
    },
    {
        code: '3',
        type: t`Production`,
        isRackbeatStepVisible: true,
    },
    {
        code: '4',
        type: t`Craftsmen`,
        isRackbeatStepVisible: true,
    },
    {
        code: '5',
        type: t`Consultancy`,
    },
    {
        code: '6',
        type: t`Real estate`,
    },
    {
        code: '7',
        type: t`Association`,
    },
    {
        code: '8',
        type: t`Accounting`,
    },
    {
        code: '9',
        type: t`Healthcare`,
    },
    {
        code: '10',
        type: t`Transport`,
    },
    {
        code: '11',
        type: t`Holding`,
    },
    {
        code: '12',
        type: t`Financial`,
    },
    {
        code: '13',
        type: t`Other`,
    },
];
